
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/lti-registration-lp",
      function () {
        return require("private-next-pages/next/lti-registration-lp/index.tsx");
      }
    ]);
  